module.exports = __webpack_public_path__ + "static/media/ios-sync.1344a6e6.svg";